import { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { MobileFiltersModal } from "components/pages/search/components/MobileFiltersModal";
import { PriceFilters } from "components/pages/search/components/PriceFilters";
import { SearchBarMobileFilterButton } from "components/pages/search/components/SearchBarMobileFilterButton/SearchBarMobileFilterButton";
import { AppContext, PropertyListingContext } from "components/store/source";
import { GuestCounterInline, Text } from "components/ui/source";

import CollectionsDatePicker from "./CollectionsDatePicker";

import styles from "./SearchBar.module.scss";

function SearchBar({ className }) {
  const { openMobileFiltersModal } = useContext(AppContext);
  const { filters } = useContext(PropertyListingContext);

  const pricingFilter = {
    selected: { min: null, max: null },
    options: { min: 0, max: 1000 },
    ...(filters?.pricingFilter || {}),
  };

  return (
    <div
      className={classnames(
        styles.container,
        !filters && styles.disabled,
        className,
      )}
    >
      <CollectionsDatePicker className={styles.datePicker} />
      <div className={classnames(styles.filter, styles.desktopFilter)}>
        <GuestCounterInline size="sm" noIcon />
        <PriceFilters className={styles.priceFilter} data={pricingFilter} />
      </div>
      <div className={classnames(styles.filter, styles.mobileFilter)}>
        <GuestCounterInline size="sm" noIcon />
        <SearchBarMobileFilterButton onClick={openMobileFiltersModal}>
          <Text
            translateKey="filters.amenitiesFilters.title_filters"
            types={["inline"]}
            className={styles.mobileFilterText}
          />
        </SearchBarMobileFilterButton>
        <MobileFiltersModal l1Theme={true} pricingData={pricingFilter} />
      </div>
    </div>
  );
}

SearchBar.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.object,
};

SearchBar.defaultProps = {
  filters: null,
};

export default SearchBar;
